import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const FacebookIcon = forwardRef<SVGSVGElement, Partial<IconProps>>(function FacebookIcon({
  styles,
  ...props
}, ref) {
  return <Icon styles={styles} viewBox="0 0 24 24" title="Facebook" description="Facebook logo" ref={ref} {...props}>
        <path {...stylex.props([iconsStyles.neutralElement])} d="M24 12a12 12 0 10-13.9 12v-8.5h-3v-3.4h3V9.4c0-3 1.8-4.6 4.6-4.6.9 0 1.8 0 2.6.2v3h-1.5a1.7 1.7 0 00-2 1.8v2.3h3.4l-.5 3.4h-2.8V24A12 12 0 0024 12.1z" />
      </Icon>;
});